__turbopack_context__.v({
  "addButton": "BlackList-module__uBCJsG__addButton",
  "inputWrapper": "BlackList-module__uBCJsG__inputWrapper",
  "list": "BlackList-module__uBCJsG__list",
  "listItem": "BlackList-module__uBCJsG__listItem",
  "removeButton": "BlackList-module__uBCJsG__removeButton",
});
